export async function makeApiRequest(path) {
	try {
		const token = localStorage.getItem("token");
		const response = await fetch(path, {
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + token,
            }
        });
		return response.json();
	} catch (error) {
		throw new Error(`QRT Solutions API request error: ${error.status}`);
	}
}

export function generateSymbol(exchange, fromSymbol, toSymbol) {
	const short = `${fromSymbol}/${toSymbol}`;
	return {
		short,
		full: `${exchange}:${short}`,
	};
}

export function parseFullSymbol(fullSymbol) {
	const match = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/);
	if (!match) {
		return null;
	}
	return {
		exchange: match[1],
		fromSymbol: match[2],
		toSymbol: match[3],
	};
}